export default class wt {
  constructor(t, s, i, h, l) {
    (this.triggerId = t),
      (this.Yr = s),
      (this.Ur = i),
      (this.Zr = h),
      (this.sn = l),
      (this.triggerId = t),
      (this.Yr = s),
      (this.Ur = i),
      (this.Zr = h),
      (this.sn = l);
  }
  static fromJson(t, s, i, h, l) {
    return null == t || null == t.trigger_id
      ? null
      : new wt(t.trigger_id, s, i, h, l);
  }
}
